import styled from 'styled-components';

export default styled.svg<{ cssWidth?: string; cssHeight?: string }>`
  width: ${(props) => props.cssWidth || '100%'};
  height: ${(props) => props.cssHeight || '100%'};
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/IconSVG.tsx